export default "__VITE_ASSET__BLNi0Bpc__"